export default __webpack_public_path__ + "static/media/lock.f33668e7.png";